module.exports = __webpack_public_path__ + "static/media/btn_1.11b2d0d2.png";